import { TdsItem, Env, Version } from '../enum/tds';
import BuglySvg from './images/bugly.svg';
import FueLogo from './images/fue.png';
import HippySvg from './images/hippy.svg';
import KuiklySvg from './images/kuikly.svg';
import MmkvSvg from './images/mmkv.svg';
import RaftSvg from './images/raft.svg';
import RightlySvg from './images/rightly.svg';
import ShiplySvg from './images/shiply.svg';
import TdsSvg from './images/tds.svg';
import WCDBSvg from './images/wcdb.svg';
import WujiSvg from './images/wuji.svg';
import WujieSvg from './images/wujie.svg';

export const PRO_HOME_URL = 'https://tds.qq.com';
export const PRO_TEST_HOME_URL = 'https://t.tds.qq.com';
export const WOA_HOME_URL = 'https://tds-union.woa.com';
export const WOA_TEST_HOME_URL = 'https://tds-union.testsite.woa.com';

export const NAVIGATION_URL = {
  [TdsItem.Home]: {
    [Version.WOA]: {
      [Env.TEST]: WOA_TEST_HOME_URL,
      [Env.PROD]: WOA_HOME_URL,
    },
    [Version.PRO]: {
      [Env.TEST]: PRO_TEST_HOME_URL,
      [Env.PROD]: PRO_HOME_URL,
    },
  },
  [TdsItem.Bugly]: {
    [Version.WOA]: {
      [Env.TEST]: 'https://t.bugly.woa.com',
      [Env.PROD]: 'https://bugly.woa.com',
    },
    [Version.PRO]: {
      [Env.TEST]: 'https://t.bugly.tds.qq.com',
      [Env.PROD]: 'https://bugly.tds.qq.com',
    },
  },
  [TdsItem.Wuji]: {
    [Version.WOA]: {
      [Env.TEST]: 'https://xy.woa.com/xy/app/test/portal/home',
      [Env.PROD]: 'https://xy.woa.com/xy/app/prod/portal/home',
    },
    [Version.PRO]: {
      [Env.TEST]: 'https://wujicode.cn/xy/app/test/official/index',
      [Env.PROD]: 'https://wujicode.cn/xy/app/prod/official/index',
    },
  },
  [TdsItem.Kuikly]: {
    [Version.WOA]: {
      [Env.TEST]: 'https://tdf-homepage-oa-y7fz9joo4.fue.woa.com/',
      [Env.PROD]: 'https://framework.tds.woa.com',
    },
    [Version.PRO]: {
      [Env.TEST]: 'https://t.framework.tds.qq.com/',
      [Env.PROD]: 'https://framework.tds.qq.com/',
    },
  },
  [TdsItem.Hippy]: {
    [Version.WOA]: {
      [Env.TEST]: 'https://tdf-homepage-oa-y7fz9joo4.fue.woa.com/',
      [Env.PROD]: 'https://framework.tds.woa.com',
    },
    [Version.PRO]: {
      [Env.TEST]: 'https://t.framework.tds.qq.com/',
      [Env.PROD]: 'https://framework.tds.qq.com/',
    },
  },
  [TdsItem.Shiply]: {
    [Version.WOA]: {
      [Env.TEST]: 'https://test.shiply.tds.woa.com',
      [Env.PROD]: 'https://shiply.tds.woa.com',
    },
    [Version.PRO]: {
      [Env.TEST]: 'https://test.shiply.tds.qq.com',
      [Env.PROD]: 'https://shiply.tds.qq.com',
    },
  },
  [TdsItem.Rightly]: {
    [Version.WOA]: {
      [Env.TEST]: 'https://t.rightly.woa.com/',
      [Env.PROD]: 'https://rightly.woa.com/ ',
    },
    [Version.PRO]: {
      [Env.TEST]: 'https://test.rightly.tds.qq.com?utm_source=tds_homepage',
      [Env.PROD]: 'https://rightly.tds.qq.com?utm_source=tds_homepage',
    },
  },
  [TdsItem.Fue]: {
    [Version.WOA]: {
      [Env.TEST]: 'https://fue.test.woa.com/home',
      [Env.PROD]: 'https://fue.woa.com/home',
    },
    [Version.PRO]: {
      [Env.TEST]: 'https://fue-pro-emgbswqw3.fue.woa.com',
      [Env.PROD]: 'https://tds.qq.com/fue/',
    },
  },
  [TdsItem.Mmkv]: {
    [Version.WOA]: {
      [Env.TEST]: 'https://tds-union.testsite.woa.com/mmkv',
      [Env.PROD]: 'https://tds-union.woa.com/mmkv/',
    },
    [Version.PRO]: {
      [Env.TEST]: 'https://mmkv-pro-s37b6sn6k.fue.woa.com',
      [Env.PROD]: 'https://tds.qq.com/mmkv/',
    },
  },
  [TdsItem.Raft]: {
    [Version.WOA]: {
      [Env.TEST]: 'https://tds-union.testsite.woa.com/raft',
      [Env.PROD]: 'https://tds-union.woa.com/raft/',
    },
    [Version.PRO]: {
      [Env.TEST]: 'https://raft-pro-c6jaq1o88.fue.woa.com',
      [Env.PROD]: 'https://tds.qq.com/raft/',
    },
  },
  [TdsItem.Wujie]: {
    [Version.WOA]: {
      [Env.TEST]: 'https://tds-union.testsite.woa.com/wujie',
      [Env.PROD]: 'https://tds-union.woa.com/wujie/',
    },
    [Version.PRO]: {
      [Env.TEST]: 'https://wujie-pro-l13y0dajs.fue.woa.com',
      [Env.PROD]: 'https://tds.qq.com/wujie/',
    },
  },
  [TdsItem.WCDB]: {
    [Version.WOA]: {
      [Env.TEST]: 'https://tds-union.testsite.woa.com/wcdb',
      [Env.PROD]: 'https://tds-union.woa.com/wcdb/',
    },
    [Version.PRO]: {
      [Env.TEST]: 'https://wcdb-pro-huunh7e4o.fue.woa.com',
      [Env.PROD]: 'https://tds.qq.com/wcdb/',
    },
  },
  [TdsItem.More]: {
    [Version.WOA]: {
      [Env.TEST]: '',
      [Env.PROD]: '',
    },
    [Version.PRO]: {
      [Env.TEST]: '',
      [Env.PROD]: '',
    },
  },
};

export const MOBILE_NAVIGATION = [
  {
    title: '首页',
    key: TdsItem.Home,
    icon: TdsSvg,
  },
  {
    title: 'Bugly',
    key: TdsItem.Bugly,
    icon: BuglySvg,
  },
  {
    title: 'Shiply',
    key: TdsItem.Shiply,
    icon: ShiplySvg,
  },
  {
    title: 'Rightly',
    key: TdsItem.Rightly,
    icon: RightlySvg,
  },
  {
    title: 'WUJI',
    key: TdsItem.Wuji,
    icon: WujiSvg,
  },
  {
    title: 'Kuikly',
    key: TdsItem.Kuikly,
    icon: KuiklySvg,
  },
  {
    title: 'Hippy',
    key: TdsItem.Hippy,
    icon: HippySvg,
  },
  {
    title: 'FUE',
    key: TdsItem.Fue,
    icon: FueLogo,
  },
  {
    title: 'MMKV',
    key: TdsItem.Mmkv,
    icon: MmkvSvg,
  },
  {
    title: 'RAFT',
    key: TdsItem.Raft,
    icon: RaftSvg,
  },
  {
    title: 'WUJIE',
    key: TdsItem.Wujie,
    icon: WujieSvg,
  },
  {
    title: 'WCDB',
    key: TdsItem.WCDB,
    icon: WCDBSvg,
  },
];

export const PC_NAVIGATION = [
  {
    title: '首页',
    key: TdsItem.Home,
  },
  {
    title: '监控定位',
    key: TdsItem.Bugly,
  },
  {
    title: '智能低代码',
    key: TdsItem.Wuji,
  },
  {
    title: '跨平台框架',
    key: TdsItem.Kuikly,
  },
  {
    title: '全场景发布',
    key: TdsItem.Shiply,
  },
  {
    title: '应用合规',
    key: TdsItem.Rightly,
  },
  {
    title: '更多产品',
    key: TdsItem.More,
  },
];

interface MoreApp {
  title: string;
  desc: string;
  icon: string;
  key: TdsItem;
}

export const MORE_APPS: MoreApp[] = [
  {
    title: 'tds-FUE',
    desc: '专为现代Web开发设计的研运一体化基建平台，由前端一体化Oteam协同打造，旨在整合腾讯公司内部工具与基础设施，简化前端研发与部署全流程，提供覆盖研发、部署到运营的全链路集成化解决方案。',
    icon: FueLogo,
    key: TdsItem.Fue,
  },
  {
    title: 'tds-RAFT',
    desc: '一套标准化的组件解决方案，致力于推动组件标准化，并以此为基础构建包含组件市场、度量可视化、快速部署和服务规范在内的完整组件生态。',
    icon: RaftSvg,
    key: TdsItem.Raft,
  },
  {
    title: 'tds-MMKV',
    desc: '由微信团队开发并已在 GitHub 上开源的高性能KV组件，提供跨平台、高并发、零延迟的本地存储解决方案。通过内存映射（mmap）与Protobuf序列化的深度优化，性能可达传统方案的300倍，完美适配高频数据读写、多进程协作等严苛场景。',
    icon: MmkvSvg,
    key: TdsItem.Mmkv,
  },
  {
    title: 'tds-WUJIE',
    desc: '无界（WUJIE）是由腾讯无极开发并已在 GitHub上开源的微前端框架，基于 Web Components + iframe 技术构建。该框架致力于解决现有微前端方案在适配成本、样式隔离和运行性能等方面的核心痛点，提供具备原生隔离、高性能和丰富功能的微前端解决方案。',
    icon: WujieSvg,
    key: TdsItem.Wujie,
  },
  {
    title: 'tds-WCDB',
    desc: '由微信团队开发并已在 GitHub 上开源的业界领先终端数据库。它全面支持 C++、Java、Kotlin、Swift 和 Objc 五种开发语言，覆盖 Android、iOS、macOS、Windows、Linux 及鸿蒙Next 六大终端平台，并提供数据备份、修复、迁移、压缩等多项业界领先的数据管理能力，助力多端应用高效、可靠地实现数据持久化。',
    icon: WCDBSvg,
    key: TdsItem.WCDB,
  },
];
